'use strict';

/** @type {import('./type')} */
module.exports = TypeError;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-errors/type.js
// module id = 4
// module chunks = 0